import { SETTLEMENT_STYLES } from "../../style/styles";

import FeeScheduleNetClientCapsule from "./FeeScheduleNetClientCapsule";
import FeeScheduleValueRow from "./FeeScheduleValueRow";

const ROWS = [
  {
    key: "otherDeductions",
    label: "Other Deductions",
    amountKey: "otherDeductions",
    percentKey: "otherDeductionsPercentage",
    colorKey: "otherDeductions",
  },
  {
    key: "attorneyFees",
    label: "Attorney's Fees",
    amountKey: "attorneyFees",
    percentKey: "attorneyFeesPercentage",
    colorKey: "attorneyFees",
  },
  {
    key: "medicalFees",
    label: "Medical Fees + Fees",
    amountKey: "medicalFees",
    percentKey: "medicalFeesPercentage",
    colorKey: "medicalFees",
  },
  {
    key: "clientPayout",
    label: "Client Payout",
    amountKey: "clientPayout",
    percentKey: "clientPayoutPercentage",
    colorKey: "clientPayout",
  },
];

export default function FeeScheduleValueList({
  values,
  chartColors,
  activeSliceName,
  onHoverSlice,
  onLeaveSlice,
}) {
  return (
    <div
      className="flex flex-col rounded-[12px] border px-3 py-2"
      style={SETTLEMENT_STYLES.subtleBorder}
    >
      {ROWS.map((row) => (
        <FeeScheduleValueRow
          key={row.key}
          title={row.label}
          amount={values[row.amountKey]}
          color={chartColors[row.colorKey]}
          isActive={activeSliceName === row.label}
          onMouseEnter={() => onHoverSlice(row.label)}
          onMouseLeave={onLeaveSlice}
          percentExists={Number(values[row.percentKey] || 0) > 0}
        />
      ))}
      <FeeScheduleNetClientCapsule value={values.netToClient} />
    </div>
  );
}
